import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'gatsby';

import OfferingsList from '../OfferingsList';
import { SERVICES_ROUTE } from '../../routes';

const Offerings = () => {
  return (
    <div className="Offerings">
      <Container>
        <Row>
          <Col sm="12" md="4">
            <h2 className="Offerings__title">
              <span className="text-blue">What</span>{" "}
              <span className="text-orange">Cloudnexa</span>{" "}
              <span className="text-blue">Does Best</span>
            </h2>
            <div className="Offerings__lead">
              AWS Premier Partner expertise at your finger tips, crafting success with AWS
            </div>

            <Link className="btn btn-outline-primary" to={SERVICES_ROUTE}>
              Learn More
            </Link>
          </Col>
          <Col sm="12" md="8">
            <OfferingsList />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Offerings;
